<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2018-->

<div class="login-container">
  <div class="row">
    <div class="col-md-12">
      <div class="text-center m-b-md">
        <div class="text-center m-b-md">
          <img src="/assets/images/logo.svg" width="125" height="100" />
        </div>
      </div>
      <div class="hpanel">
        <div class="panel-body">
          <h3 class="text-center m-t-none m-b-md">Reset your password</h3>
          <form id="loginForm" (ngSubmit)="sendPasswordReset()">
            <div class="form-group">
              <label class="control-label">Email</label>
              <input type="text" placeholder="example@gmail.com" title="Please enter your email" class="form-control"
                name="email" [(ngModel)]="passwordReset.email" [ngModelDebounce]="500"
                (ngModelDebounceChange)="update()" />
            </div>

            <div *ngIf="groups" class="form-group">
              <label class="control-label">Group</label>
              <select class="form-control" [(ngModel)]="passwordReset.group" name="group">
                <option value="undefined" disabled selected>
                  -- Select a group --
                </option>
                <option *ngFor="let group of groups; trackBy: trackByGroupId" [value]="group._id">
                  {{ group.name }}
                </option>
              </select>
            </div>

            <!--
              Cloudflare Turnstile renders here (see renderTurnstile()). In managed mode
              it usually resolves with no interaction; the button below stays disabled
              until it hands us a token.
            -->
            <div class="form-group">
              <div id="nexleader-turnstile-container-password-reset"></div>
            </div>

            <button type="submit" class="btn btn-success btn-block"
              [attr.disabled]="!isReadyToAdvance() ? true : null">
              Send Link
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 text-center">
      <strong>IPSAT</strong> <br />
      {{ currentYear }} Copyright nexleader
    </div>
  </div>
</div>